export default __webpack_public_path__ + "locales/sr-Latn-RS/PeopleTranslations.json?hash=3d576bf21da7265c2814de8ce1249726";